<template>
    <div style="display: flex;flex-direction: column;height: 100%;width: 100%;position: absolute;top: 0;left: 0;">
        <!-- 下单弹窗 -->
        <el-drawer :visible.sync="drawer" direction="btt" size="90%">
            <component v-if="itemDetail !== null" style="width: 100%;height: 100%;" :is="drawerComponent"
                :itemPrice="itemDetail.itemPrice" :companyId="itemDetail.companyId" :itemName="itemDetail.itemName"
                :itemHeadImg="itemDetail.itemHeadImg"
                :itemId="itemDetail.id" @createOrder="handleOrderMessage"></component>
        </el-drawer>
        <!-- 下单弹窗 -->
        <div :style="{ height: contentHeight + 'px' }" style="width: 100%;overflow: auto;  scrollbar-width: none;
  -ms-overflow-style: none;display: flex;align-items: center; ">
            <div class="columnformat" id="columnformat" style="">
                <div style="width: 100%;display: flex;flex-direction: column;align-items: center;" v-if="itemDetail">
                    <el-carousel height="200px" style="width: 100%;" indicator-position="none" :loop="true"
                        :interval="10000">
                        <el-carousel-item v-for="item, index in itemDetail.itemHeadImg.split(';')" :key="index">
                            <img :src="resourceBase + '/assets/itemImg/' + item"
                                style="width: 100%;height: 100%;object-fit: cover;" alt="">
                        </el-carousel-item>
                    </el-carousel>
                    <div style="border-radius: 10px 10px 0 0;width: 100%;display: flex;flex-direction: column;align-items: center;position: absolute;top: 180px;z-index: 100;background: #F5F5F5;"
                        :style="{ paddingBottom: bottomheight + 'px' }">

                        <div
                            style="color: #FC5531;border-radius:10px;padding: 10px;width: calc(100% - 20px);display: flex;flex-direction: column;align-items: center;background: white;">
                            <div
                                style="width: calc(100% - 4px);text-align: left;font-size: small;font-weight: 700;display: flex;justify-content: space-between;align-items: center;">
                                <div>{{ itemDetail.discount }}折</div>
                                <div>已售{{ itemDetail.itemSales }}</div>
                            </div>
                            <div
                                style="width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;justify-content: space-between;">
                                <div style="display: flex;align-items: center;margin: 10px 0;">
                                    ¥<div style="font-size: xx-large;">{{ itemDetail.itemPrice }}</div>
                                </div>
                            </div>
                            <div
                                style="font-size: large;color: black;width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;">
                                {{ itemDetail.itemName }}
                            </div>
                            <div
                                style="margin-top: 10px;font-size: small;color: black;width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;">
                                <div style="width: 40px;">上门</div>
                                <div style="color: grey;">深圳市三核保龙环保科技有限公司</div>
                            </div>
                            <div
                                style="margin-top: 10px;font-size: small;color: black;width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;">
                                <div style="width: 40px;">须知</div>
                                <div style="color: grey;">需预约,购买后90天内有效</div>
                            </div>
                            <div
                                style="margin-top: 10px;font-size: small;color: black;width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;">
                                <div style="width: 40px;">保障</div>
                                <div style="color: grey;">随时退,过期退</div>
                            </div>
                            <div
                                style="margin-top: 10px;font-size: small;color: black;width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;">
                                <div style="width: 40px;">门店</div>
                                <div style="color: grey;">当前门店适用</div>
                            </div>
                        </div>
                        <div
                            style="font-size: large;width: 100%;text-align: left;padding: 10px;width: calc(100% - 20px);font-weight: 700;">
                            服务详情</div>
                        <div
                            style="color: #FC5531;border-radius:10px;padding: 10px;width: calc(100% - 20px);display: flex;flex-direction: column;align-items: center;background: white;">
                            <div
                                style="margin-top: 10px;font-size: small;color: black;width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;">
                                <div style="width: 60px;">适用部位</div>
                                <div style="color: grey;">全面部</div>
                            </div>
                            <div
                                style="margin-top: 10px;font-size: small;color: black;width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;">
                                <div style="width: 60px;">适用性别</div>
                                <div style="color: grey;">女性</div>
                            </div>
                            <div
                                style="margin-top: 10px;font-size: small;color: black;width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;">
                                <div style="width: 60px;">适用肤质</div>
                                <div style="color: grey;">油性肌肤,混油肌肤</div>
                            </div>
                            <div
                                style="margin-top: 10px;font-size: small;color: black;width: calc(100% - 4px);text-align: left;font-weight: 700;display: flex;align-items: center;">
                                <div style="width: 60px;">服务次数</div>
                                <div style="color: grey;">1次</div>
                            </div>
                        </div>
                        <div
                            style="font-size: large;width: 100%;text-align: left;padding: 10px;width: calc(100% - 20px);font-weight: 700;">
                            图文详情</div>
                        <div
                            style="color: #FC5531;border-radius:10px;padding: 10px;width: calc(100% - 20px);display: flex;flex-direction: column;align-items: center;background: white;">
                            <img style="width: 100%;margin-top: 10px;"
                                v-for="imgItem, imgIndex in itemDetail.itemDescImg.split(';')" :key="imgIndex"
                                :src="resourceBase + '/assets/itemImg/' + imgItem" alt="">
                        </div>
                        <div v-if="commentInfo != null"
                            style="font-size: large;width: 100%;text-align: left;padding: 10px;width: calc(100% - 20px);font-weight: 700;">
                            用户评价({{ commentInfo.commentCount }})</div>
                        <div v-if="commentInfo != null"
                            style="color: #FC5531;border-radius:10px;padding: 10px;width: calc(100% - 20px);display: flex;flex-direction: column;align-items: center;background: white;">
                            <div style="width: 100%;display: flex;justify-content: space-between;">
                                <div style="display: flex;align-items: center;width: 100%;">
                                    <img src="../assets/五角星.png"
                                        style="width: 30px;height: 30px;background: black;border-radius: 50%;" alt="">
                                    <div
                                        style="display: flex;flex-direction: column;margin-left: 5px;color: black;flex: 1;align-items: flex-start;">
                                        <div style="width: 100%;display: flex;align-items: center;">
                                            <div style="font-weight: 700;text-align: left;flex: 1;">{{
                                                commentInfo.tComment.userName }}</div>
                                            <div style="color: grey;">{{ commentInfo.tComment.submitTime }}</div>
                                        </div>

                                        <el-rate v-model="commentInfo.tComment.score" :colors="colors">
                                        </el-rate>
                                    </div>
                                </div>
                            </div>
                            <div style="width: 100%;color: black;text-align: left;">{{ commentInfo.tComment.content }}
                            </div>
                            <div style="width: 100%;display: flex;margin-top: 10px;">
                                <img style="width: 30%;margin-right: 5px;"
                                    v-for="commentImg, commentImgIndex in commentInfo.tComment.commentImg.split(';')"
                                    :key="commentImgIndex"
                                    :src="resourceBase + '/assets/commentImg/' + commentImg" alt="">
                            </div>
                            <el-button style="margin-top: 10px;width: 100%;">全部{{ commentInfo.commentCount
                                }}条评价</el-button>
                        </div>
                        <div id="bottomBar"
                            style="width: 100%; position: fixed ;bottom: 0;background: white;z-index: 102;">
                            <div style="display: flex;align-items: center;padding: 10px;width: calc(100% - 20px);">
                                <div style="display: flex;flex-direction: column;padding: 10px;align-items: center;">
                                    <img style="width: 20px;height: 20px;margin-bottom: 5px;" src="../assets/门店.png"
                                        alt="">
                                    <div style="color: grey;font-size: small;">门店</div>
                                </div>
                                <div style="display: flex;flex-direction: column;padding: 10px;align-items: center;">
                                    <img style="width: 20px;height: 20px;margin-bottom: 5px;" src="../assets/客服.png"
                                        alt="">
                                    <div style="color: grey;font-size: small;">在线客服</div>
                                </div>
                                <div style="display: flex;align-items: center;flex: 1;justify-content: flex-end;">
                                    <div @click="drawer = true"
                                        style="background: #FCBC23;padding: 10px;color: white;border-radius: 10px 0 0 10px;font-weight: 700;">
                                        上门服务</div>
                                    <div
                                        style="background: #FC5531;padding: 10px;color: white;border-radius: 0 10px 10px 0;display: flex;align-items: center;">
                                        <div style="font-weight: 700;margin-right: 5px;">立即抢购</div>
                                        <div>¥{{ itemDetail.itemPrice }}</div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div style="width: 100%;margin: 20px 0;" :style="{
                            height: $store.state.indexBarHeight + 10 + 'px'
                        }">
                            <a href="https://beian.miit.gov.cn/" target="_blank">ICP备案号</a>
                            <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026080515号-2</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
.el-drawer__header {
    display: none !important;
}

.columnformat {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: white;
    overflow: auto;
}
</style>

<script>
import request from "../axios/request";
import HomeServiceOrder from "./HomeServiceOrder.vue";
export default {
    name: "CompanyItemView",
    components: {
        HomeServiceOrder
    },
    data() {
        return {
            drawerComponent: 'HomeServiceOrder',
            drawer: false,
            contentHeight: null,
            resourceIp: null,
            resourceBase: /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname) ? 'https://yuanhuihuanhuan.com' : window.location.origin,
            itemId: null,
            itemDetail: null,
            commentInfo: null,
            colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
            bottomheight: null,
            companyType: null
        }
    },
    mounted() {
        this.itemId = this.$route.params.itemId;
        const resizeObserver = new ResizeObserver((entries) => {
            requestAnimationFrame(() => {
                for (const entry of entries) {
                    this.contentHeight = window.innerHeight
                    this.bottomheight = document.getElementById("bottomBar").offsetHeight
                }
            });
        });
        resizeObserver.observe(document.getElementById("columnformat"));
        this.getCompanyItemDetailById();
        this.getCommentInfoByItemId();
        this.resourceIp = this.extractIPFromURL(window.location.origin);



    },
    methods: {
        handleOrderMessage(orderId) {
            this.drawer = false;
            this.$router.push({
                path: '/OrderInfoView/' + orderId
            })
        },
        async getCommentInfoByItemId() {
            // 这里应该调用接口获取服务器详情，目前先模拟数据
            let res = await request({
                url: '/comment/api/getCommentInfoByItemId?itemId=' + this.itemId,
                method: 'get',
            })
            if (res.data.status === 200) {
                this.$nextTick(() => {
                    this.commentInfo = res.data.data;
                });
            }
        },
        async getCompanyItemDetailById() {
            let res = await request({
                url: '/item/api/getItemDetailById?itemId=' + this.itemId,
                method: 'get',
            })
            if (res.data.status === 200) {
                this.$nextTick(() => {
                    this.itemDetail = res.data.data;
                });
            }
        },
        extractIPFromURL(url) {
            try {
                // 方法1：优先使用浏览器原生URL对象解析（兼容现代浏览器）
                const parsedUrl = new URL(url);
                const hostname = parsedUrl.hostname;

                // 如果是IPv6地址（如[2001:db8::1]），去除方括号
                if (hostname.startsWith('[') && hostname.endsWith(']')) {
                    return hostname.slice(1, -1);
                }

                // 如果是IPv4地址或域名，直接返回
                return hostname;
            } catch (e) {
                // 方法2：URL对象解析失败时，使用正则表达式作为兜底方案
                const ipv4Regex = /(?:\d{1,3}\.){3}\d{1,3}/; // 匹配IPv4
                const domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/i; // 匹配域名[1,4](@ref)

                // 尝试匹配IPv4
                const ipMatch = url.match(ipv4Regex);
                if (ipMatch) return ipMatch[0];

                // 尝试匹配域名
                const domainMatch = url.match(domainRegex);
                if (domainMatch && domainMatch[1]) {
                    return domainMatch[1].replace(/^www\./, ''); // 可选：去除www前缀
                }

                return null; // 均未匹配时返回null
            }
        }
    }
}
</script>
